import { render, staticRenderFns } from "./ModalJustificativa.vue?vue&type=template&id=e64778ac&"
import script from "./ModalJustificativa.vue?vue&type=script&lang=js&"
export * from "./ModalJustificativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports